import PartnerCard from './PartnerCard';

class Partnership {
  static MIN_RATE = 0;
  static ACTIVE = 'ACTIVE';
  static INACTIVE = 'INACTIVE';
  static APPROVED = 'APPROVED';

  constructor() {
    this.selectedId = null;
    this.childProjects = [];
    this.link = null;
    this.maxAvailableRate = null;
    this.parentProjectId = null;
    this.parentProjectName = null;
    this.rate = Partnership.MIN_RATE;
    this.rateChangePermission = false;
    this.referralProgramStatus = Partnership.INACTIVE;
  }

  // eslint-disable-next-line complexity
  setData(data) {
    if (data?.childProjects) {
      this.childProjects = data.childProjects.map(item => new PartnerCard(item));
    }
    this.link = data?.link || null;
    this.maxAvailableRate = data?.maxAvailableRate || null;
    this.parentProjectId = data?.parentProjectId || null;
    this.parentProjectName = data?.parentProjectName || null;
    this.rate = data?.rate || Partnership.MIN_RATE;
    this.rateChangePermission = data?.rateChangePermission || false;
    this.referralProgramStatus = data?.referralProgramStatus || Partnership.INACTIVE;
  }

  setChildProjects(projects) {
    this.childProjects = projects || [];
  }

  pushChildProjects(projects) {
    this.childProjects.push(...(projects || []));
  }

  updateData({ parentProjectId, parentProjectName }) {
    this.parentProjectId = parentProjectId;
    this.parentProjectName = parentProjectName;
  }

  isActive() {
    return this.referralProgramStatus === Partnership.ACTIVE;
  }

  removeFromChildProjects(projectId) {
    this.childProjects = this.childProjects.filter(project => project.id !== projectId);
  }

  setRate(rate) {
    this.rate = rate;
  }

  setBrowsingPermission(projectId, status) {
    const updatedProject = this.childProjects.find(project => project.id === projectId);
    if (!updatedProject) {
      return;
    }
    updatedProject.transactionBrowsingRequestStatus = status;
    updatedProject.transactionsBrowsingPermission = status === Partnership.APPROVED;
  }

  mergeChild(childProjects) {
    if (!childProjects) {
      return;
    }
    childProjects
      .map(project => new PartnerCard(project))
      .forEach(project => {
        const existedIndex = this.childProjects.findIndex(childProject => project.id === childProject.id);
        if (existedIndex !== -1) {
          this.childProjects[existedIndex] = project;
        } else {
          this.childProjects.push(project);
        }
      });
  }
}

export default Partnership;
